module.exports = __webpack_public_path__ + "static/media/BuildingChromeExtensions.83cedab3.png";